<template>
  <div class="orderMenu">
    <div class="orderMenu-meta">
      <span class="orderMenu-date">
        {{ month }}月{{ date }}日（{{ thisWeekDay }}）
      </span>
      <div
        class="orderMenu-time"
        :data-vacuumperiod="vacuumPeriod"
        :data-checkrock="checkRock"
        :class="{
          locked: vacuumPeriod <= 0 && checkRock,
          noavailable: vacuumPeriod < 0
        }"
      >
        <div v-on:click="changeTime({ order: order }, 'pm')">
          <btnToggle
            class="order-state__btn"
            btnTxt="指定日PM"
            color="primary"
            :class="{ on: order[orderNum].thisDayTime == 'pm' }"
          />
        </div>
        <div v-on:click="changeTime({ order: order }, 'am')">
          <btnToggle
            class="order-state__btn"
            btnTxt="翌日AM"
            color="negative"
            :class="{ on: order[orderNum].thisDayTime == 'am' }"
          />
        </div>
      </div>
    </div>

    <div class="orderMenu-list">
      <div
        class="orderMenu-list__item"
        v-for="product in products"
        :key="product.item_id"
        :class="{ positive: product.quantity + product.add_quantity > 0 }"
      >
        <span class="orderMenu-name">
          <span
            class="label-deadline over"
            v-if="extra && extraPeriod - product.deadlineAddOrder < 0"
          >
            受付終了
          </span>
          <span
            class="label-deadline over"
            v-if="
              extra && extraPeriod - product.deadlineAddOrder == 0 && checkRock
            "
          >
            受付終了
          </span>
          <span
            class="label-deadline today"
            v-if="
              extra && extraPeriod - product.deadlineAddOrder == 0 && !checkRock
            "
          >
            本日締切
          </span>

          <span class="orderMenu-name__txt">{{ product.name }}</span>
          <span v-if="dev" class="dev"
            >ロック状態：{{ checkRock }}<br />
            transferDays : {{ transferDays }} extraPeriod : {{ extraPeriod
            }}<br />

            {{ product.deadlineAddOrder }}日前までオーダー可能</span
          >
        </span>
        <div class="orderMenu-amount">
          <input
            type="number"
            class="orderMenu-amount__num"
            @change="quantityChange($event, product, orderNum)"
            :value="product.quantity + product.add_quantity"
          />
          <span class="orderMenu-amount__unit">{{ product.unit }}</span>
        </div>
        <span
          @click="
            minus(product, {
              itemID: product.item_id,
              index: orderNum
            })
          "
          class="orderMenu-amount__btn orderMenu-amount__minus"
        >
        </span>
        <span
          @click="
            plus(product, {
              targetProduct: product,
              event: $event,
              index: orderNum
            })
          "
          class="orderMenu-amount__btn orderMenu-amount__plus"
        >
        </span>
      </div>
    </div>
  </div>
</template>

<script>
// import { mapMutations } from 'vuex'
import btnToggle from "@/components/btn/btnToggle";
export default {
  name: "orderMenuAdd",
  data: function() {
    return {
      today: "",
      extraPeriod: "", //追加発注の期限
      vacuumPeriod: "", //真空の期限 発送日の前日
      dev: false
    };
  },
  computed: {
    order: function() {
      return this.$store.state.shopOrder.data.order;
    },
    //配達日数 //shopの都道府県でtransferのdaysを検索
    transferDays: function() {
      return this.$store.state.shopOrder.data.transferDays;
    }
    // products : function(){
    //   return this.$store.state.products
    // },
  },
  props: {
    year: Number,
    month: Number,
    date: Number,
    thisWeekDay: String,
    orderNum: Number,
    extra: Boolean,
    products: Array,
    checkRock: Boolean
  },
  components: {
    btnToggle
  },
  watch: {
    date: function() {
      let thisDay = new Date(this.year, this.month - 1, this.date); //到着日
      //追加発注の期限
      this.extraPeriod = (thisDay - this.today) / 86400000; //到着日 - 今日の日付 - 配達日数 なか日 - 配達日数（基準日）
      //真空の期限
      //到着日 - 今日の日付 - 今日の日付 - 配達日数 なか日 - 配達日数（基準日）- 1
      this.vacuumPeriod =
        (thisDay - this.today) / 86400000 - this.transferDays - 1;
    }
  },
  mounted() {
    let domain = document.domain;
    if (domain == "localhost" || domain.indexOf("192.168") > -1) {
      this.dev = true;
    }

    let thisDay = new Date(this.year, this.month - 1, this.date);
    // let weekday = thisDay.getDay();
    // this.thisWeekDay = [ "日", "月", "火", "水", "木", "金", "土" ][weekday]
    // this.today = new Date(2022, 1, 6);
    const thisOrderDay = new Date(this.year, this.month - 1, this.date);
    //追加発注の期限
    // 到着日 - 今日の日付 - 配達日数 なか日 - 配達日数（基準日）
    this.extraPeriod = (thisOrderDay - this.today) / 86400000;
    //真空の期限
    //到着日 - 今日の日付 - 今日の日付 - 配達日数 なか日 - 配達日数（基準日）- 1
    this.vacuumPeriod =
      (thisDay - this.today) / 86400000 - this.transferDays - 1;
    console.log({ thisOrderDay });
    console.log("today : " + this.today);
    console.log((thisOrderDay - this.today) / 86400000);
    console.log("extraPeriod : " + this.extraPeriod);
  },
  beforeMount() {
    //今日の日付
    const getDate = new Date();
    const y = getDate.getFullYear();
    const m = getDate.getMonth();
    const d = getDate.getDate();
    this.today = new Date(y, m, d);
  },
  methods: {
    // ...mapMutations(["plus", "minus"]),
    changeTime(order, time) {
      order.order[this.orderNum].thisDayTime = time;
    },
    quantityChange(event, product, index) {
      if (event) {
        product.add_quantity = parseInt(event.target.value, 10);
      }
      if (product.add_quantity < 0) {
        product.add_quantity = 0;
      }
      this.$store.commit("mathTotalData", { index: index });
    },
    plus(product, param) {
      //追加発注時 締切を過ぎていたら変更不可
      if (this.extra && this.extraPeriod - product.deadlineAddOrder < 0) {
        return;
      }
      //追加発注時 ロックがかかっていたら本日締切分は変更不可
      if (
        this.extra &&
        this.extraPeriod - product.deadlineAddOrder <= 0 &&
        this.checkRock == true
      ) {
        return;
      }
      product.add_quantity = product.add_quantity + product.orderUnit;
      if (
        product.add_quantity > 0 &&
        product.add_quantity + product.quantity < product.minimumQuantity
      ) {
        product.add_quantity = product.minimumQuantity;
        console.log("B");
      }
      this.quantityChange(null, product, param.index);
      // this.$store.commit("plus", param);
      // this.$store.commit("mathTotalData", { index: param.index });
    },
    minus(product, param) {
      //追加発注時 締切を過ぎていたら変更不可
      if (this.extra && this.extraPeriod - product.deadlineAddOrder < 0) {
        return;
      }
      //追加発注時 ロックがかかっていたら本日締切分は変更不可
      if (
        this.extra &&
        this.extraPeriod - product.deadlineAddOrder <= 0 &&
        this.checkRock == true
      ) {
        return;
      }
      if (product.add_quantity <= 0) {
        return;
      }
      product.add_quantity = product.add_quantity - product.orderUnit;
      if (
        product.add_quantity > 0 &&
        product.add_quantity + product.quantity < product.minimumQuantity
      ) {
        product.add_quantity = 0;
      }

      let q = product.quantity;
      let aq = product.add_quantity;
      let totalQ = q + aq;
      let vq = product.vacuumQuantity;
      let avq = product.addVacuumQuantity;
      let totalVq = vq + avq;

      let dif = totalVq - totalQ;

      //発注量より真空が多くなった場合
      if (dif > 0) {
        if (dif > avq) {
          product.addVacuumQuantity = 0;
          product.vacuumQuantity = dif - avq;
        } else {
          product.addVacuumQuantity = avq - dif;
        }
      }

      this.quantityChange(null, product, param.index);
      // this.$store.commit("minus", param);
      // this.$store.commit("mathTotalData", { index: param.index });
    }
  }
};
</script>

<style scoped lang="scss">
@use '@/css/utility/_colors' as colors;
@use '@/css/utility/_mixin' as mixin;
@use '@/css/utility/_media' as media;
@use '@/css/utility/_font' as font;
@use '@/css/utility/_variables' as variables;
.orderMenu {
  width: 100%;
  position: relative;
  &.seeing {
    .order-state {
      transform: translateY(0);
    }
  }
}
.orderMenu-meta {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding-right: 15px;
}
.orderMenu-time {
  display: flex;
  &.noavailable,
  &.locked {
    pointer-events: none;
  }
  .order-state__btn {
    margin-left: 10px;
  }
}
.orderMenu-date {
  width: 100%;
  height: 60px;
  display: block;
  @extend .f_pageTtl;
  box-sizing: border-box;
  padding: 0 15px;
  display: flex;
  align-items: center;
  margin-right: auto;
}
.holiday {
  .orderMenu-date {
    color: variables.$sunday;
  }
}
.saturday {
  .orderMenu-date {
    color: variables.$saturday;
  }
}
.orderMenu-list__item {
  display: flex;
  align-items: center;
  width: 100%;
  height: 60px;
  background: variables.$bg-gray-1;
  box-sizing: border-box;
  padding-left: 17px;
  border-bottom: solid 1px variables.$bg-gray-2;
  position: relative;

  .orderMenu-name__txt,
  .orderMenu-amount {
    opacity: 0.2;
    transition: all 0.5s ease-in-out;
  }
  &.positive {
    .orderMenu-name__txt,
    .orderMenu-amount {
      opacity: 1;
    }
  }
}
.orderMenu-name {
  @extend .f_body;
  width: 175px;
  margin-right: auto;
}
.orderMenu-amount {
  display: flex;
  align-items: flex-end;
  position: absolute;
  right: 135px;
  top: -30%;
  height: 100%;
  input {
    pointer-events: none;
  }
}
.orderMenu-amount__num {
  //width: 35px;
  @extend .f_number;
  text-align: right;
  padding-right: 5px;
  box-sizing: border-box;
  pointer-events: none;
}
.orderMenu-amount__unit {
  @extend .f_body;
  white-space: nowrap;
}
.orderMenu-amount__btn {
  width: 60px;
  height: 60px;
  background: linear-gradient(#f4f4f4 0%, #ededed 100%);
  position: relative;
  box-sizing: border-box;
  cursor: pointer;
  z-index: 2;
  &:before {
    content: "";
    width: 12px;
    height: 1px;
    background: variables.$scrollbar-back;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.orderMenu-amount__minus {
  border-right: solid 1px variables.$border-1;
  margin-left: 15px;
}
.orderMenu-amount__plus {
  &:after {
    content: "";
    width: 1px;
    height: 12px;
    background: variables.$scrollbar-back;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.label-deadline {
  position: relative;

  z-index: 3;
  font-size: 11px;
  font-weight: 700;
  color: #fff;

  width: 53px;
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  &.over {
    background: variables.$txt-default;
  }
  &.today {
    background: variables.$negative;
  }
}

.dev {
  font-size: 10px;
  display: flex;
  width: 400px;
  flex-wrap: wrap;
  position: absolute;
  pointer-events: none;
  top: 50%;
  left: 100px;
  transform: translate(0, -50%) scale(0.9);
  opacity: 0.4;
  padding: 5px;
  background: #000;
  color: #fff;
  text-shadow: 0 0 2px rgba(0, 0, 0, 1);
}
</style>
